<si-generic-dialog [(displayDialog)]="displayDialog"
                   dialogTitle="SI_CONFIRM_ATTENDANCE"
                   button1Text="SI_CONFIRM"
                   button1Class="si-button_main"
                   [button1Close]="false"
                   button2Text="SI_CANCEL"
                   button2Class="si-button_secondary"
                   (updateButton1Change)="onClickCloseDialogConfirmAttendance(true)"
                   (displayDialogChange)="onClickCloseDialogConfirmAttendance(false)">
  <div>
    <div class="mb-3">{{'SI_CONFIRM_ATTENDANCE_TEXT' | translate}}</div>
    <div class="pasi-subtitle mb-2">{{serviceName}}</div>
    <div class="row fb-gap-v-small mb-4">
      <div *ngIf="startDate" class="col-6 col-sm-4 col-lg-3">
        <div class="pasi-grey-box_data">{{startDate | amDateFormat: 'L'}}</div>
        <div class="pasi-grey-box_field">{{'SI_DATE' | translate}}</div>
      </div>
      <div *ngIf="startDate" class="col-6 col-sm-4 col-lg-3">
        <div class="pasi-grey-box_data">{{startDate | amDateFormat: 'LT'}}{{hour}}</div>
        <div class="pasi-grey-box_field">{{'SI_HOUR' | translate}}</div>
      </div>
      <div *ngIf="assistanceTypeName" class="col-12 col-sm-4 col-lg-3">
        <div class="pasi-grey-box_data">{{assistanceTypeName | translate}}</div>
        <div class="pasi-grey-box_field">{{'SI_ASSISTANCE_TYPE' | translate}}</div>
      </div>
    </div>
    <div [innerHTML]="('SI_CONFIRM_ATTENDANCE_INFO' | translate)"></div>
  </div>
</si-generic-dialog>
